import React from "react";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  /** 패널 폭 등을 조절하는 추가 클래스 */
  className?: string;
}

/**
 * 임의의 콘텐츠를 담는 일반 모달(팝업) 셸.
 * 확인/취소 버튼이 있는 Dialog와 달리, 콘텐츠를 그대로 보여주고 닫기만 제공한다.
 */
const Popup: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  children,
  className = "max-w-[560px]",
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-60 z-[100000]"
        onClick={onClose}
      />

      {/* Panel */}
      <div
        className="fixed inset-0 z-[100001] flex items-center justify-center p-4 pointer-events-none"
        onClick={onClose}
      >
        <div
          className={`bg-white rounded-[12px] shadow-2xl w-full relative pointer-events-auto max-h-[85vh] overflow-y-auto ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 transition-colors z-10"
            aria-label="닫기"
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="p-6 py-8">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Popup;
